import './slider'
import './faq'
import './menu-header'
import './summary'
// import './prognostic-table'
import './betting-slider'
import './sidebar'
// import './mwai-chatbot'
import './instant-search'
